<template>
  <div>
    <div class="integration-list-grid mb-3">
      <div class="text-xl font-bold text-text leading-tight">{{ mainLabel }}</div>
      <div class="text-sm text-text text-right">{{ $t('accountsAmount') }}</div>
      <div class="text-sm text-text text-right">{{ $t('connectedAccounts') }}</div>
      <div class="text-sm text-text text-right">{{ $t('updatedAt') }}</div>
      <div></div>
    </div>
    <div class="divide-y divide-line">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: "IntegrationsList",
  props: {
    mainLabel: {
      type: String
    }
  },
  i18n: {
    messages: {
      en: {
        accountsAmount: 'Accounts total',
        connectedAccounts: 'Connected',
        updatedAt: 'Updated at',
      },
      ru: {
        accountsAmount: 'Всего счетов',
        connectedAccounts: 'Подключено',
        updatedAt: 'Обновлено',
      }
    }
  }
}
</script>

<style>
.integration-list-grid {
  @apply grid items-center;
  grid-template-columns: 3fr 1fr 1fr 1.5fr .6fr;
}
</style>